<div *ngIf="contactGroup">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>groups</mat-icon> {{!contactGroup.id ? 'Create new Contact Group' : contactGroup.name}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{!contactGroup.id ? 'add' : 'save'}}</mat-icon>
        {{(contactGroup.id ? 'Update ' : 'Add ')}}
      </button>
      <micro-delete-confirm *ngIf="contactGroup.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>

  <div class="padded">
    <form #form="ngForm" role="form" class="vbox">
      <table class="basicTable vtable">
        <thead>
        <tr>
          <th colspan="100">Contact Group Details</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="isCompanyAdmin">
          <th><micro-valid-label for="companyId" [model]="companyId" label="Company"></micro-valid-label></th>
          <td>
            <micro-company-select #companyId="ngModel"
                                  [(ngModel)]="contactGroup.companyId"
                                  [required]="true"
                                  [disabled]="auth.companyIdFilter"
                                  (companyIdChange)="onCompanyIdChanged()"
                                  id="companyId"
                                  name="companyId">
            </micro-company-select>
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th>
          <td>
            <input #name="ngModel" [(ngModel)]="contactGroup.name" required placeholder="Name" maxlength="50" id="name" name="name">
          </td>
        </tr>
        </tbody>
      </table>
    </form>
  </div>

  <div class="padded">
    <mat-toolbar><mat-icon>people</mat-icon> Group Members</mat-toolbar>
    <div class="lightly-padded">
      <micro-picklist *ngIf="contacts"
                      [all]="contacts"
                      [(selectedIds)]="contactGroup.members"
                      availableLabel="Unassigned Contacts (Comp/Dept/Contact)"
                      selectedLabel="Assigned Contacts (Comp/Dept/Contact)"
                      filterLabel="Contact"
                      displayField="plDisplayName"
      >
      </micro-picklist>
    </div>
  </div>
</div>
